import Link from 'next/link';
import { FC } from 'react';

import { TOrder } from '@/types/orders';

import { useTranslate } from '@/shared/hooks/use-translate';
import { Location3Icon, PhoneIcon } from '@/shared/ui/icons';
import { formats } from '@/shared/utils/formats';

import * as Styled from './styled';

type Props = {
    order: TOrder;
};

export const Court: FC<Props> = ({ order }): JSX.Element => {
    const { t } = useTranslate();
    const officerLaw = order.jurist.executor;

    return (
        <Styled.Wrapper>
            <div>
                <Styled.Data>
                    <Styled.Title>{t('Ваш судебный исполнитель')}</Styled.Title>
                    <span>{officerLaw?.name}</span>
                </Styled.Data>
            </div>
            <Styled.Flex>
                {officerLaw?.address && (
                    <Styled.IconBox>
                        <Location3Icon />
                    </Styled.IconBox>
                )}
                <Styled.Data>
                    <Styled.Title>{t('Адрес')}</Styled.Title>
                    <span>{officerLaw?.address}</span>
                </Styled.Data>
            </Styled.Flex>
            <Styled.Flex>
                {officerLaw?.phones && (
                    <Styled.IconBox>
                        <PhoneIcon />
                    </Styled.IconBox>
                )}
                <Styled.Data>
                    <Styled.Title>{t('Контактные данные')}</Styled.Title>

                    {officerLaw?.phones && (
                        <div>
                            <Link href={`tel:${officerLaw.phones}`}>{formats.phone(officerLaw.phones)}</Link>
                        </div>
                    )}
                </Styled.Data>
            </Styled.Flex>
        </Styled.Wrapper>
    );
};
